module.exports = __webpack_public_path__ + "static/img/select-img7.06e5364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/select-img7.png
// module id = GFrW
// module chunks = 1